import React from 'react';

import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function ExpandedList2Icon(): JSX.Element {
  return (
    <SvgIcon style={{ height: 90, width: 62 }} viewBox="0 0 62 83">
      <g fill="none" fillRule="evenodd">
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -5)"
        >
          <tspan x="0" y="13">
            1)
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -5)"
        >
          <tspan x="0" y="85">
            2)
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -5)"
        >
          <tspan x="11" y="30">
            a)
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -5)"
        >
          <tspan x="11" y="48">
            b)
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -5)"
        >
          <tspan x="22" y="66">
            i)
          </tspan>
        </text>
        <path
          d="M15 8H62V10H15zM15 80H62V82H15zM31 25H62V27H31zM31 43H62V45H31zM40 61H62V63H40z"
          fill={IconColors.Grey}
          transform="translate(0 -5)"
        />
      </g>
    </SvgIcon>
  );
}
